<!-- src/views/LocalCurico.vue -->
<template>
  <div class="local-curico">
    <!-- Wrapper flex: texto e imagen -->
    <div class="local-flex">
      <!-- Texto primero en mobile -->
      <div class="info-box" :class="{ 'info-box-visible': show }">
        <h2>📌 R O D A S E P­ ㅤC U R I C Ó</h2>
        <p class="headline">Ven a conocernos en Curicó</p>
        <p class="description">
          En nuestra sucursal de Rodasep en Curicó encontrarás una selección
          integral de productos y servicios. Si requieres orientación experta,
          recoger tu pedido o simplemente quieres saludarnos, nuestras puertas
          en Curicó están siempre abiertas para ti.
        </p>
        <ul class="features">
          <li
            v-for="(item, index) in features"
            :key="index"
            :class="{ 'feature-visible': show }"
            :style="{ animationDelay: `${0.8 + index * 0.2}s` }"
          >
            <i :class="item.icon"></i>
            <span>
              {{ item.text }}<br />
              <small>{{ item.subtext }}</small>
            </span>
          </li>
        </ul>
      </div>

      <!-- Imagen del local -->
      <img
        v-if="show"
        class="drop-image"
        src="@/assets/images/locales/rodasep_local_curico.webp"
        alt="Local Curico"
      />
    </div>

    <!-- Rectángulo azul de fondo -->
    <div class="rectangulo-azul"></div>

    <!-- LOGOS y MAPA 1 -->
    <div class="test-content" ref="mapContent1">
      <div class="map-logos" :class="{ 'fade-in': isMapVisible1 }">
        <img
          src="@/assets/images/logos/rodasep-logo-hd.webp"
          alt="Rodasep Logo"
        />
        <img
          src="@/assets/images/logos/googlemaps.webp"
          alt="Google Maps Logo"
        />
        <div class="whatsapp-send">
          <a
            href="https://api.whatsapp.com/send?text=📍%20Ubicación%20Rodasep%20Curicó:%20https://maps.app.goo.gl/twhcobxhWzJqE7cz5"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="@/assets/images/logos/enviar-a-whatsapp.webp"
              alt="Enviar a WhatsApp"
              class="whatsapp-button"
            />
          </a>
        </div>
      </div>

      <!-- Mapa Google Maps -->
      <iframe
        :class="['map-embed', { 'map-visible': isMapVisible1 }]"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d350.1189035776302!2d-71.23295617002438!3d-34.98752463824196!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x966457af24898999%3A0x1b722fe6ef25766a!2sFrancisco%20Bilbao%2039%2C%203341878%20Curic%C3%B3%2C%20Maule!5e1!3m2!1sen!2scl!4v1749861374704!5m2!1sen!2scl"
        loading="lazy"
        allowfullscreen
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>

    <!-- LOGOS y MAPA Street View -->
    <div class="test-content-two" ref="mapContent2">
      <div class="map-logos" :class="{ 'fade-in': isMapVisible2 }">
        <img
          src="@/assets/images/logos/rodasep-logo-hd.webp"
          alt="Rodasep Logo"
        />
        <img
          src="@/assets/images/logos/googlestreet.webp"
          alt="Google Street View Logo"
        />
      </div>
      <iframe
        :class="['map-embed', { 'map-visible': isMapVisible2 }]"
        src="https://www.google.com/maps/embed?pb=!4v1749861066709!6m8!1m7!1s2TxQOFV9dIRO5_OoDNbtxw!2m2!1d-34.98760585835354!2d-71.23282077132897!3f353.0618994844225!4f-6.997080177765838!5f0.624485869761668"
        loading="lazy"
        allowfullscreen
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, reactive } from "vue";

const show = ref(false);
const isMapVisible1 = ref(false);
const isMapVisible2 = ref(false);
const mapContent1 = ref(null);
const mapContent2 = ref(null);

const features = reactive([
  {
    icon: "icon-cloud-rain",
    text: "Estamos ubicados en calle Francisco Bilbao Nº39",
    subtext: "Revisa nuestro local desde Google Maps",
  },
  {
    icon: "icon-heart",
    text: "De lunes a viernes",
    subtext: "Toda la semana disponible a tu servicio",
  },
  {
    icon: "icon-shop",
    text: "Desde las 9:00 de la mañana hasta las 6:00 de la tarde",
    subtext: "Horario de invierno",
  },
]);

// Función para verificar si un elemento está visible en el viewport
const isElementInViewport = (el) => {
  if (!el) return false;
  const rect = el.getBoundingClientRect();
  return (
    rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.bottom >= 0
  );
};

// Función para comprobar la visibilidad de los mapas
const checkMapVisibility = () => {
  if (isElementInViewport(mapContent1.value) && !isMapVisible1.value) {
    isMapVisible1.value = true;
  }
  if (isElementInViewport(mapContent2.value) && !isMapVisible2.value) {
    isMapVisible2.value = true;
  }
};

onMounted(() => {
  // Iniciar animación principal con un poco de retraso
  setTimeout(() => (show.value = true), 300);

  // Configurar detector de scroll para las animaciones de los mapas
  window.addEventListener("scroll", checkMapVisibility);

  // Comprobar una vez inicialmente (en caso de que los mapas estén visibles desde el principio)
  setTimeout(checkMapVisibility, 500);
});
</script>

<style scoped>
.local-curico {
  position: relative;
  margin-top: 50px;
  --drop-duration: 1.5s;
  --img-width: 50%;
  --rect-height: 490px;
}

.drop-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: var(--rect-height);
  object-fit: cover;
  object-position: center;
  z-index: 10;
  opacity: 0;
  transform: translateY(-5px) scale(1.05);
  animation: floatIn var(--drop-duration) cubic-bezier(0.34, 1.56, 0.64, 1)
    forwards;
}

@keyframes floatIn {
  0% {
    transform: translateY(-5px) scale(1.05);
    opacity: 0;
  }
  100% {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

.rectangulo-azul {
  width: 100%;
  height: var(--rect-height);
  background-color: #00a3e0;
  /* Glow permanente de XXpx en negro semitransparente */
  filter: drop-shadow(0 0 15px rgba(1, 0, 8, 0.6));
  position: relative;
  z-index: 1;
}

.info-box {
  position: absolute;
  top: 0;
  left: 50%;
  width: 50%;
  height: var(--rect-height);
  padding: 1rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff; /* texto blanco */
  z-index: 15; /* por encima de la imagen */
  font-family: var(--heading-font); /* usa tu fuente global */
  opacity: 0;
  transform: translateX(20px);
  transition: opacity 1s ease, transform 1s ease;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2), 0 0 2px rgba(0, 0, 0, 0.1);
}

.info-box-visible {
  opacity: 1;
  transform: translateX(0);
}

/* — Tipografía interior — */
/* R O D A S E P CURICO*/
.info-box h2 {
  margin: 0;
  font-size: 1.9rem;
  font-weight: 400;
  opacity: 0.7;
  text-transform: uppercase;
}
.info-box .headline {
  margin: 0.5rem 0 1rem;
  font-size: 2rem;
  line-height: 1.2;
  color: #130670; /*old:  a87438 */
  font-size: 2.5rem; /* Ajusta este valor según necesites */
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2), 0 0 2px rgba(0, 0, 0, 0.1);
}
.info-box .description {
  margin-bottom: 1.5rem;
  opacity: 0.8;
  font-size: 1rem; /* Ajusta este valor según necesites */
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2), 0 0 2px rgba(0, 0, 0, 0.1);
}

/* — Lista de iconos + texto — */
.info-box .features {
  list-style: none;
  padding: 0;
  margin: 10px 0 0 0;
}
.info-box .features li {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
  opacity: 0;
  transform: translateY(15px);
}
.info-box .features li.feature-visible {
  animation: fadeUp 0.7s ease-out forwards;
}

@keyframes fadeUp {
  0% {
    opacity: 0;
    transform: translateY(15px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.info-box .features li:last-child {
  margin-bottom: 10px;
}
.info-box .features i {
  font-size: 1.5rem;
  margin-right: 1rem;
}
.info-box .features span {
  line-height: 1.2;
}
.info-box .features small {
  display: block;
  opacity: 0.7;
  font-size: 0.875rem;
}

.test-content {
  margin-top: 70px;
  padding: 0 3rem;
  text-align: center;
}
.test-content-two {
  margin-top: 70px;
  padding: 0 3rem;
  text-align: center;
}

.map-logos {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.map-logos.fade-in {
  opacity: 1;
  transform: translateY(0);
}

.map-logos img {
  height: 3em;
  vertical-align: middle;
  margin-left: 5px;
}

.map-embed {
  width: 100%;
  height: 450px;
  border: none;
  margin-top: 90px;
  opacity: 0;
  transform: scale(0.95);
  transition: opacity 1s ease, transform 1s ease, filter 1s ease;
  /* Glow sutil inicial */
  filter: drop-shadow(0 0 5px rgba(116, 144, 155, 0.5));
}

.map-embed.map-visible {
  opacity: 1;
  transform: scale(1);
  /* Glow final más intenso */
  filter: drop-shadow(0 0 10px rgba(116, 144, 155, 0.8));
}

/* Estilo para el boton de compartir whatsapp*/
.whatsapp-send {
  text-align: center;
  margin-top: 1.5rem;
}
.whatsapp-button {
  display: inline-block;
  max-width: 150px; /* ajusta a tu gusto */
  width: 100%;
  height: auto;
  cursor: pointer;

  /* sombra inicial (contorno fino) */
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));

  /* animación suave de transform y filter */
  transition: transform 0.3s ease, filter 0.3s ease;
}

/* un poco más de sombra al pasar sobre él, para darle "elevación" */
.whatsapp-button:hover {
  filter: drop-shadow(0 5px 5px rgba(0, 0, 0, 0.3));
  transform: translateY(-2px);
}

/* al hacer click, se hunde 2px y la sombra se hace más pequeña */
.whatsapp-button:active {
  transform: translateY(2px);
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3));
}

/* ---- CAMBIOS RESPONSIVOS ---- */
@media (max-width: 992px) {
  .local-curico {
    --rect-height: 550px;
  }

  .info-box {
    padding-right: 2rem;
  }

  .info-box h2 {
    font-size: 1.7rem;
  }

  .info-box .headline {
    font-size: 1.8rem;
  }
}

@media (max-width: 768px) {
  .local-curico {
    --rect-height: 750px;
    margin-top: 30px;
  }

  .drop-image {
    width: 100%;
    height: 50%;
    object-position: center top;
    left: 0;
  }

  .info-box {
    top: 50%;
    left: 0;
    width: 100%;
    height: 50%;
    padding: 1.5rem;
  }

  .map-logos img {
    height: 2.5em;
    margin: 5px;
  }

  .test-content,
  .test-content-two {
    padding: 0 1.5rem;
  }

  .map-embed {
    height: 350px;
    margin-top: 60px;
  }
}

@media (max-width: 576px) {
  .local-curico {
    --rect-height: 850px;
  }

  .drop-image {
    height: 40%;
  }

  .info-box {
    top: 40%;
    height: 60%;
  }

  .info-box h2 {
    font-size: 1.5rem;
  }

  .info-box .headline {
    font-size: 1.6rem;
    margin: 0.3rem 0 0.8rem;
  }

  .info-box .description {
    font-size: 0.95rem;
  }

  .info-box .features li {
    margin-bottom: 1.5rem;
  }

  .info-box .features i {
    font-size: 1.3rem;
  }

  .info-box .features span {
    font-size: 0.95rem;
  }

  .info-box .features small {
    font-size: 0.8rem;
  }

  .map-logos img {
    height: 2em;
  }

  .test-content,
  .test-content-two {
    margin-top: 40px;
    padding: 0 1rem;
  }

  .map-embed {
    height: 300px;
    margin-top: 40px;
  }

  .whatsapp-button {
    max-width: 130px;
  }

  /*Estilo responsivo*/
  .local-flex {
    display: flex;
    flex-direction: row;
    position: relative;
  }

  @media (max-width: 768px) {
    .local-flex {
      flex-direction: column;
    }

    .info-box {
      order: 1;
    }

    .drop-image {
      order: 2;
    }
  }

  @media (max-width: 768px) {
    .rectangulo-azul {
      display: none; /* ya no lo necesitamos en mobile */
    }

    .local-flex {
      display: flex;
      flex-direction: column;
      position: static;
    }

    .info-box {
      position: static;
      width: 100%;
      padding: 1.5rem;
      background-color: #00a3e0;
      color: white;
      text-align: center;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      transform: none !important;
      opacity: 1 !important;
    }

    .drop-image {
      position: static;
      width: 100%;
      height: auto;
      object-fit: cover;
      margin-top: 0;
    }
  }

  @media (max-width: 768px) {
    .info-box {
      text-align: center;
      padding: 2rem 1.5rem;
    }

    .info-box h2 {
      font-size: 1.4rem;
      margin-bottom: 0.6rem;
    }

    .info-box .headline {
      font-size: 1.7rem;
      margin-bottom: 1rem;
      color: #130670;
    }

    .info-box .description {
      font-size: 1rem;
      line-height: 1.6;
      margin-bottom: 1.5rem;
    }

    .info-box .features {
      padding: 0;
      margin: 0 auto;
    }

    .info-box .features li {
      margin-bottom: 1.5rem;
      display: block;
      text-align: center;
    }

    .info-box .features i {
      display: block;
      font-size: 1.3rem;
      margin-bottom: 0.3rem;
    }

    .info-box .features span {
      font-size: 1rem;
      line-height: 1.4;
    }

    .info-box .features small {
      font-size: 0.85rem;
      opacity: 0.8;
    }
  }
}
</style>
